(function($) {

/* Navigation Toggle
   ========================================================================== */

$(document).on('click', '.navigation-toggle', function(event) {
	event.preventDefault();
	$(this).toggleClass('navigation-toggle-active');
	$('#header').toggleClass('navigation-open');
});

}(jQuery));
